import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { TouchableOpacity, TextStyle, ViewStyle } from 'react-native'
import { useHistory } from 'react-router'

import { Button as MuiButton, InputAdornment, TextField } from '@mui/material'
import { ChevronLeftRounded, EmailRounded } from '@mui/icons-material'
import { useStores } from '@trivie/core'
import {
  Button,
  color,
  iconApple,
  iconAppleWhite,
  iconGoogle,
  SvgIcon,
  Text,
} from '@trivie/ui-mobile'

export const MagicLinkScreen = () => {
  const { userStore } = useStores()

  const history = useHistory()
  const { control, watch, handleSubmit } = useForm()
  const { email_address } = watch()

  const sendMagicLink = () => {
    userStore.setEmail(email_address)
    userStore.sendMagicLink(email_address, 'com.trivie.engage.aha').then(() => {
      history.push('/login/magic/sent')
    })
  }

  const btnStyle = {
    ...SUBMIT,
    backgroundColor: !email_address || !email_address?.includes('@') ? color.shade20 : color.blue,
    opacity: !email_address || !email_address?.includes('@') ? 0.4 : 1.0,
  }

  return (
    <div style={ROOT}>
      <div style={CONTAINER}>
        <div style={CONTENT}>
          <div style={HEADER}>
            <Text style={HEADLINE} tx="Onboarding.Login.secureLogin" variant="headline" />
            <Text variant="titleMedium" style={TAGLINE} tx="Onboarding.Login.useMagicLink" />
          </div>
          <Controller
            control={control}
            defaultValue=""
            render={({ onChange, onBlur, value }) => (
              <TextField
                type="email"
                required
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                style={{ width: 335, marginBottom: 51 }}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailRounded htmlColor={color.black} />
                    </InputAdornment>
                  ),
                }}
                helperText={
                  email_address && !email_address.includes('@')
                    ? 'Enter a valid email address.'
                    : ''
                }
                placeholder="Your Email Address"
                error={typeof email_address === 'string' && !email_address.includes('@')}
              />
            )}
            name="email_address"
            rules={{ required: true }}
          />
          <Button
            disabled={!email_address || !email_address.includes('@')}
            style={btnStyle}
            tx="Onboarding.Login.getMagicLink"
            onPress={handleSubmit(sendMagicLink)}
            accessibilityRole="button"
            accessibilityLabel="Send Magic Link"
          />
          <div
            style={{
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              width: 375,
              paddingRight: 20,
              paddingLeft: 20,
              marginBottom: 40,
            }}
          >
            <div style={{ height: 1, width: '100%', backgroundColor: color.shade20 }} />
            <Text variant="titleEmphasized" tx="Common.or" style={{ marginHorizontal: 10 }} />
            <div style={{ height: 1, width: '100%', backgroundColor: color.shade20 }} />
          </div>
          <div style={{ marginBottom: 72 }}>
            {/* <TouchableOpacity
              style={SSO_BTN}
              onPress={() =>
                window.location.replace(
                  `${process.env.REACT_APP_SSO_MS_URL}?app_id=com.trivie.engage.aha`,
                )
              }
            >
              <div style={{ marginTop: 4, marginRight: 15 }}>
                <SvgIcon src={iconMicrosoft} />
              </div>
              <Text style={SSO_BTN_TXT} tx="Onboarding.Login.microsoftContinue" />
            </TouchableOpacity> */}
            <TouchableOpacity
              style={SSO_BTN}
              onPress={() =>
                window.location.replace(
                  `${process.env.REACT_APP_SSO_GOOG_URL}?app_id=com.trivie.engage.aha`,
                )
              }
            >
              <div style={{ marginTop: 4, marginRight: 15 }}>
                <SvgIcon src={iconGoogle} />
              </div>
              <Text style={SSO_BTN_TXT} tx="Onboarding.Login.googleContinue" />
            </TouchableOpacity>
            <TouchableOpacity
              style={{ ...SSO_BTN, backgroundColor: color.black, marginBottom: 32 }}
              onPress={() =>
                window.location.replace(
                  `${process.env.REACT_APP_SSO_APPLE_URL}?app_id=com.trivie.engage.aha`,
                )
              }
            >
              <div style={{ top: 12, marginRight: 15 }}>
                <SvgIcon src={iconAppleWhite} />
              </div>
              <Text style={{ ...SSO_BTN_TXT, color: '#fff' }} tx="Onboarding.Login.appleContinue" />
            </TouchableOpacity>
            {/* <TouchableOpacity style={SSO_BTN} onPress={handleSubmit(onSubmit)}>
              <View style={{ top: 12, right: 15 }}>
                <SvgIcon src={iconLock} color="#000" />
              </View>
              <Text style={SSO_BTN_TXT} text={'Continue with SSO'} />
            </TouchableOpacity> */}
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row' }}>
              <MuiButton
                onClick={() => history.replace('/login')}
                style={{ textTransform: 'none' }}
                startIcon={<ChevronLeftRounded style={{ color: color.shade70, fontSize: 24 }} />}
              >
                Back
              </MuiButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ROOT: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
}
const CONTAINER: React.CSSProperties = {
  flexDirection: 'column',
  flex: 1,
  display: 'flex',
  maxHeight: 576,
  justifyContent: 'space-evenly',
  width: '100%',
  alignSelf: 'center',
}
const CONTENT: React.CSSProperties = {
  height: '100%',
  flex: 1,
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'center',
}
const HEADER: React.CSSProperties = { minWidth: 319, flexDirection: 'column', display: 'flex' }
const SUBMIT: ViewStyle = {
  marginHorizontal: 20,
  backgroundColor: color.palette.blue,
  width: 335,
  alignSelf: 'center',
  marginBottom: 50,
}
const TAGLINE: TextStyle = {
  opacity: 0.5,
  textAlign: 'center',
  marginBottom: 50,
  width: 319,
}
const HEADLINE: TextStyle = { textAlign: 'center', marginBottom: 12 }
const SSO_BTN: ViewStyle = {
  marginBottom: 12,
  width: 335,
  backgroundColor: color.white,
  borderColor: color.shade20,
  borderWidth: 1,
  borderRadius: 16,
  height: 52,
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
}
const SSO_BTN_TXT: TextStyle = {
  fontSize: 17,
  fontWeight: '600',
  color: 'rgba(0,0,0,0.54)',
  lineHeight: 22.61,
}
